module.exports = __webpack_public_path__ + "img/last-page.bfe1af08.svg";